module.exports = __webpack_public_path__ + "img/event-note.8342a204.svg";